import { render } from "./HardKeyDebugOverlay.vue?vue&type=template&id=1632d172&scoped=true"
import script from "./HardKeyDebugOverlay.vue?vue&type=script&lang=ts"
export * from "./HardKeyDebugOverlay.vue?vue&type=script&lang=ts"

import "./HardKeyDebugOverlay.vue?vue&type=style&index=0&id=1632d172&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1632d172"

export default script